import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { SettingsRoute } from '../../../enums/settingsRoute'
import { SettingsTabItem, UseSettingsTabItems } from '../types'

export const useUserSettingsTabItems = (): UseSettingsTabItems => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  const items: SettingsTabItem[] = [
    {
      route: SettingsRoute.Profile,
      text: t('settings.user.profile'),
    },
    {
      route: SettingsRoute.ProfileNotifications,
      text: t('settings.user.notifications'),
      hidden: organization?.brand !== 'billy', // @todo it should be also handled inside routing
    },
    {
      route: SettingsRoute.ProfilePrivacy,
      text: t('settings.user.privacy'),
    },
    {
      route: SettingsRoute.ProfileOrganizations,
      text: t('organizations'),
    },
  ]

  return { items }
}
